import React, { useState } from 'react'
import ImgStep1 from '../assets/rewardStep1.svg'
import ImgStep2 from '../assets/rewardStep2.png'
import ImgStep3 from '../assets/rewardStep3.png'

interface Props {
  id?: string
  setIsOpenModal?: (val: boolean) => void
  handleStartTutorial?:()=>void
}
type Step = {
  image: string
  titre: string
  paragraphe: string,
  height:number,
  width: number
}
 
const ModalInfoReward: React.FC<Props> = ({ id, setIsOpenModal, handleStartTutorial }) => {
  const [step, setStep] = useState(0)
  const ListeStep: Step[] = [
    {
      image: ImgStep1,
      width:240,
      height:245,
      titre: 'Points de Récompense (RP)',
      paragraphe: "Utilisez l'application chaque jour et effectuez des transactions pour gagner des Points de Récompense (RP).",
    },
    {
      image: ImgStep2,
      width:253,
      height:328,
      titre: 'Montez de niveau',
      paragraphe:
        "Plus vous utilisez l'application et complétez votre profil, plus vous gagnez de l'XP. En progressant de niveau, vous débloquez de nouvelles opportunités et profitez d'encore plus d'avantages dans l'application.",
    },
    {
      image: ImgStep3,
      width:241,
      height:342,
      titre: 'Utilisez vos RP',
      paragraphe: "Échangez vos Points de Récompense (RP) contre des cadeaux, des services gratuits et des récompenses exclusives dans l'application.",
    },
  ]
  const currentStep = ListeStep[step]
  const handleNext = () => {
    if (step < ListeStep.length - 1) {
      setStep((prev)=> prev + 1)
    } else {
      if(handleStartTutorial)
      {
        handleStartTutorial()
      }
      else if(setIsOpenModal) {setIsOpenModal(false)}
    }
  }
  const handleStepPointer=(index:number)=>{
    setStep(index)
  }
  return (
    <div className="fixed inset-0 bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] flex items-center justify-center z-50  ">
      <div
        className={`relative bg-white rounded-2xl sm:mx-[4px] shadow-inner flex flex-col gap-8 max-h-screen object-center w-auto sm:w-full  px-8 py-[60px] 3xl:py-[20px]`}
      >
        <div className="flex cursor-default flex-col items-center justify-center gap-5">
          <img className=' h-[340px] 2xl:h-[200px] w-auto' src={currentStep.image} width={currentStep.width} height={currentStep.height} alt={currentStep.titre} />
          <h2 className="text-[#5754E5] text-[22px] font-bold"> {currentStep.titre}</h2>
          <p className="max-w-[400px] text-center text-[#6B7280] h-[100px] overflow-y-auto scrollbar-webkit py-2">{currentStep.paragraphe}</p>
        </div>
        <div className=" flex gap-3 items-center justify-center mt-[30px] 2xl:mt-[10px]">
          {ListeStep.map(( _,index) => (
            <div
              key={index}
              onClick={()=>handleStepPointer(index)}
              className={`w-[12px] h-[12px] rounded-full cursor-pointer  ${step === index ? 'bg-[#5754E5]' : 'bg-[#D1D1FF]'} `}
            />
          ))}
        </div>
        <button
          className={`${step === ListeStep.length - 1 ? 'bg-[#5754E5] text-white' : 'text-[#5754E5]'} w-full border border-[#5754E5] rounded-[16px] h-[56px] font-bold `}
          onClick={handleNext}
        >
          {step===2 ? "C'est parti !" : 'Suivant'}
        </button>
      </div>
    </div>
  )
}

export default ModalInfoReward
